goog.provide("shadow.js.shim.module$$mui$x_date_pickers$DateTimePicker");
goog.provide("module$shadow_js_shim_module$$mui$x_date_pickers$DateTimePicker");
shadow.js.shim.module$$mui$x_date_pickers$DateTimePicker = shadow.js.nativeProvides["@mui/x-date-pickers/DateTimePicker"] = shadow$bridge("@mui/x-date-pickers/DateTimePicker");
module$shadow_js_shim_module$$mui$x_date_pickers$DateTimePicker.default = shadow.js.shim.module$$mui$x_date_pickers$DateTimePicker;
